import styled from "styled-components";
import { Anchor } from "discover.medical.react-component-library";

export const RelatedContentWrap = styled.div`
  margin-top: ${({ theme }) => theme.space.md};
`;

export const RelatedContentLink = styled(Anchor)`
  font-weight: ${({ theme }) => theme.font.weight.semibold};
`;
